// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3WK8_","title":"AfterFrontImage_title__1R-ef"};